import './_blurb-list.slider.scss';

/**
 * Slider layout for BlurbList.
 */
export default function BlurbListMap({ children, className = '' }) {
  if (!children) return null;

  return <div className={`BlurbList__map ${className}`}>{children}</div>;
}
